"use client";

import { createContext, type FC, type PropsWithChildren, useContext } from "react";
import type { PropertyValue } from "./analytics";

type FeatureTrackingContextType = Record<string, PropertyValue>;

const FeatureTrackingContext = createContext<FeatureTrackingContextType>({});

interface FeatureTrackingProviderProps {
  properties: Record<string, PropertyValue>;
}

export const FeatureTrackingProvider: FC<PropsWithChildren<FeatureTrackingProviderProps>> = ({
  properties,
  children,
}) => {
  return <FeatureTrackingContext.Provider value={properties}>{children}</FeatureTrackingContext.Provider>;
};

/**
 * Returns the current feature's core tracking properties from context.
 * Returns `{}` when no FeatureTrackingProvider exists above (safe fallback).
 */
export const useFeatureTrackingProps = (): FeatureTrackingContextType => {
  return useContext(FeatureTrackingContext);
};
